import { FactoryDTO } from 'src/app/DTOs/FactoryDTO';import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MasterDataService } from 'src/app/Services/master-data.service';
import { FormGroup, FormsModule, } from "@angular/forms";
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { CountryDTO } from 'src/app/DTOs/CountryDTO';
import { ContactPersonDTO } from 'src/app/DTOs/ContactPersonDTO';

import { NotificationService } from 'src/app/Shared/prime-ng/notification.service';
import { DataResult, DataStateChangeEvent, GridDataResult, PageChangeEvent, State, pageSkip, pageTake, process } from 'src/app/Shared/prime-ng/grid-data';
import { PrimeNgModule } from 'src/app/Shared/prime-ng/prime-ng.module';

@Component({
  selector: 'app-customer-detail',
  standalone: true,
  imports: [PrimeNgModule, FormsModule, CommonModule, RouterModule],
  templateUrl: './factory-detail.component.html',
  styleUrl: './factory-detail.component.css'
})

export class FactoryDetailComponent implements OnInit {
  factory: FactoryDTO | null = {
    factoryId: 0,
    title: '',
    country: {
      countryId: 0,
      title: '',
      iso2: null,
      iso3: null
    },
    city: '',
    zip: '',
    street: '',
    contactPersons: [],
    canBeDeleted: false
  };
  availableCountrys: CountryDTO[] = [{ countryId: 0, iso2: null, iso3: null, title: '' }]
  public contactPersons: ContactPersonDTO[] = [];
  public currentContactPersons: ContactPersonDTO[] = [];
  public originalContactPerson: ContactPersonDTO[] = [];
  public gridView: GridDataResult = { data: [], total: 0 };
  public gridState: State = { skip: 0, take: 5 };
  selectedCountryId: number = 0
  editMode: boolean = false
  cancelDialog: boolean = false

  constructor(private route: ActivatedRoute, private masterData: MasterDataService, private router: Router, private notificationService: NotificationService) { }

  ngOnInit(): void {
    this.loadFactoryDetail()
    this.getAllCountrys()
    this.updateGridView()
  }

  saveFactory() {
    if (!this.factory) {
      this.notification('No Factory was loaded!', 'error');
      return;
    }

    const selectedCountry = this.availableCountrys.find(c => c.countryId === this.selectedCountryId);
    if (!selectedCountry) {
      this.notification('Please select a Country!', 'error');
      return;
    }
    this.factory.country = selectedCountry;
    this.factory.contactPersons = this.contactPersons;

    if (this.factory.factoryId && this.factory.factoryId > 0) {
      this.masterData.updateFactory(this.factory).subscribe({
        next: () => {
          this.notification('Factory was updated', 'success');
          this.router.navigate(['/factories']);
        },
        error: () => this.notification('Error while updating Factory', 'error')
      });
    } else {
      this.masterData.createFactory(this.factory).subscribe({
        next: (id: number) => {
          this.factory!.factoryId = id;
          this.notification(`Factory was created (ID: ${id})`, 'success');
          this.router.navigate(['/factories']);
        },
        error: () => this.notification('Error while creating Factory', 'error')
      });
    }
  }


  cancelEdit() {
    this.factory = null;
    this.router.navigate([`factories/`])
  }

  getAllCountrys() {
    this.masterData.GetAllCountrys().subscribe({
      next: (res) => {
        if (res) {
          this.availableCountrys = res;
          if (this.factory) {
            if (this.factory.country && this.factory.country.countryId) {
              this.selectedCountryId = this.factory.country.countryId;
            } else {
              this.factory.country = this.availableCountrys[0];
              this.selectedCountryId = this.factory.country.countryId;
            }
          }
        }
      },
      error: () => this.notification('Error while loading countries', 'error')
    });
  }

  private updateGridView() {
    this.gridView = process(this.contactPersons, this.gridState);
  }

  public dataStateChange(state: State): void {
    this.gridState = state;
    this.updateGridView();
  }

  public addHandler() {
    try {
      const newContactPerson: ContactPersonDTO = {
        databaseId: 0,
        firstName: 'First Name',
        lastName: 'Last Name',
        canBeDeleted: true,
      };
      this.contactPersons = [...this.contactPersons, newContactPerson];
      this.updateGridView()
      this.notification('New Contactperson was added', 'success');
    } catch {
      this.notification('Error while saving Contactperson', 'error');
    }
  }
  public editHandler() {
    this.editMode = !this.editMode
    this.currentContactPersons = this.contactPersons.map(cp => ({ ...cp }))
  }

  public openCancelDialog() {
    this.cancelDialog = true;
  }

  public cancelHandler() {
    try {
      this.contactPersons = this.originalContactPerson.map(cp => ({ ...cp }))
      this.toggleCancelDialog()
      this.updateGridView();
      this.notification('Changes were canceled', 'info');
      this.router.navigate(['/factories']);
    } catch {
      this.notification('Error while canceling the changes', 'error');
    }
  }
  public saveHandler() {
    this.editMode = !this.editMode
    this.updateGridView();
  }

  public removeHandler(item: ContactPersonDTO) {
    const index = this.contactPersons.indexOf(item);
    if (index > -1) {
      this.contactPersons.splice(index, 1);
      this.updateGridView();
      this.notification(`Contactperson "${item.firstName} ${item.lastName}" was removed`, 'warning');
    }
  }

  private loadFactoryDetail() {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      this.masterData.getFactories(id).subscribe(factories => {
        this.factory = factories[0];
        if (this.factory && this.factory.country) {
          this.selectedCountryId = this.factory.country.countryId
          this.contactPersons = this.factory.contactPersons.map(cp => ({ ...cp }));
          this.originalContactPerson = this.contactPersons.map(cp => ({ ...cp }));
          this.updateGridView();
        }
      });
    }
  }

  toggleCancelDialog() {
    this.cancelDialog = !this.cancelDialog
  }

  notification(message: string, state: any) {
    this.notificationService.show({
      content: message,
      animation: { type: 'fade', duration: 400 },
      position: { horizontal: 'right', vertical: 'top' },
      type: { style: state, icon: true }
    });
  }

}